import React from 'react';
import ReactDOM from 'react-dom/client';
import { PrivyProvider } from '@privy-io/react-auth';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { env, WidgetRegistryProvider } from '@rmint/shell';
import { widgetRegistry } from './components/widgets/registry';
import './styles/tailwind.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);
const routerTree = <RouterProvider router={router} />;

// Outreach never signs a tx → no SmartWalletsProvider, no viem chain config.
// PrivyProvider is mounted only when a real appId is configured (the SDK
// throws on an empty/malformed id); dev-bypass renders without it and
// useAuth() returns the admin stub.
const tree = env.privyAppId ? (
  <PrivyProvider
    appId={env.privyAppId}
    config={{ loginMethods: ['email', 'wallet'], appearance: { theme: 'light' } }}
  >
    {routerTree}
  </PrivyProvider>
) : (
  routerTree
);

root.render(
  <WidgetRegistryProvider value={widgetRegistry}>
    <React.StrictMode>{tree}</React.StrictMode>
  </WidgetRegistryProvider>,
);
